import './card.less';

import * as React from 'react';

import { CardWeb } from './cardModules/web';
import { CardMobile } from './cardModules/mobile';

// [COMPONENT USAGE]

// Example 1 : Web card without subscription(only has the body)
/* <Card
	appearance={CardAppearances.webDefault}
	alternativeColor="yellow"
	body={() => (
		<div className="card-body">
			<img src={theme.image.recebaJaWhite} className="img mb-3" alt="" />
			<Button
				alternativeFontColor="yellow"
				primary
				text={'Test'}
				onClick={() => {
					console.log('test');
				}}
			></Button>
		</div>
	)}
></Card>; */

// Example 2: Web card with subscription( has a list of items )
/* <Card
	appearance={CardAppearances.webDefault}
	header={() => (
		<>
			<img src={theme.image.resolvaJaSvg} className="img mb-3" width="153" height="51" alt="..." />
			<div className="text-label">
				<div>Month here</div>
			</div>
			<div className="text-label-description">
				<div>description</div>
			</div>
		</>
	)}
	bodyListItems={listItemsArray} -> sets body list items - it represents each row of the body list items(text + value)
></Card>; */

export interface ListItem {
	text?: string;
	value?: string;
}

export enum CardAppearances {
	mobileDefault,
	webDefault,
}

export interface CardProps {
	/**sets the alternative color for the card(example : border color) */
	alternativeColor?: string;
	/**sets card appearance */
	appearance: CardAppearances;
	/**sets a header */
	header?: () => React.ReactNode;
	/**sets a footer */
	footer?: () => React.ReactNode;
	/**sets a body tittle */
	bodyTittle?: () => React.ReactNode;
	/**sets body list items - it represents each row of the body list items(text + value)*/
	bodyListItems?: ListItem[];
	/**sets the of the card body */
	body?: () => React.ReactNode;
	/**sets an event for the click action*/
	onClick?(event?: any): void;
}

// Card Factory
export const Card: React.FC<CardProps> = (props: CardProps): JSX.Element => {
	const { appearance } = props;
	return (
		<>
			{appearance === CardAppearances.mobileDefault && <CardMobile {...props}></CardMobile>}
			{appearance === CardAppearances.webDefault && <CardWeb {...props}></CardWeb>}
		</>
	);
};
